import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {
  CAvatar,
  CButton,
  CButtonGroup,
  CCard,
  CCardBody,
  CCardImage,
  CCardTitle,
  CCardText,
  CCardFooter,
  CCardHeader,
  CCol,
  CProgress,
  CRow,
  CTable,
  CFormSwitch,
  CImage,
  CFormCheck,
} from '@coreui/react'
import apiClient from '../../services/apiClient'
import { getStyle } from '@coreui/utils'
import { CChartBar, CChartLine } from '@coreui/react-chartjs'
import CIcon from '@coreui/icons-react'
import { cilArrowBottom, cilArrowTop, cilOptions } from '@coreui/icons'
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom'
import devicePic1 from 'src/assets/images/calendar.jpeg'
import devicePic2 from 'src/assets/images/female.jpeg'
import devicePic3 from 'src/assets/images/male.jpeg'

const WidgetsReminderUserConfig = () => {
  let navigate = useNavigate()
  const [selectedDate, setSelectedDate] = useState(null)
  const handleDateChange = (date) => {
    setSelectedDate(date)
    localStorage.setItem('birthday', date)
  }

  const handleGenderFemale = async () => {
    localStorage.setItem('gender', 'FEMALE')
    console.log('gender FEMALE')
  }

  const handleGenderMale = async () => {
    localStorage.setItem('gender', 'MALE')
    console.log('gender MALE')
  }

  return (
    <div className="small text-medium-emphasis">
      <div className="small text-medium-emphasis">
        <CCard key={1}>
          {/*<CCard key={recommendation.id}>*/}
          <CCardBody>
            <CCol>
              <CImage rounded orientation="top" src={devicePic1} width={50} height={50} />
              <CCardText>{'BIRTHDAY'}</CCardText>
              <CCardText>
                Select your birthday date
                <DatePicker
                  selected={selectedDate}
                  onChange={handleDateChange}
                  dateFormat="dd MMMM yyyy"
                />
                {selectedDate && <p>You selected: {selectedDate.toLocaleDateString()}</p>}
              </CCardText>
            </CCol>
          </CCardBody>
        </CCard>
        <CCard key={2}>
          {/*<CCard key={recommendation.id}>*/}
          <CCardBody>
            <CCol>
              <CImage rounded orientation="top" src={devicePic2} width={50} height={50} />
              <CImage rounded orientation="top" src={devicePic3} width={50} height={50} />
              <CCardText>{'GENDER'}</CCardText>
              <CFormCheck
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault1"
                label="MALE"
                onChange={handleGenderMale}
              />
              <CFormCheck
                type="radio"
                name="flexRadioDefault"
                id="flexRadioDefault2"
                label="FEMALE"
                onChange={handleGenderFemale}
              />
            </CCol>
          </CCardBody>
        </CCard>
      </div>
    </div>
  )
}

export default WidgetsReminderUserConfig
